<template>
    <transition name="notification">
        <div v-if="show" class="notification_wrapper">
            <div class="notification_header">
                <div class="icon_cover">
                    <img src="../../assets/logo-social-sniffer.svg" />
                </div>
                <span class="title_wrapper">{{ headerText }}</span>
                <span class="icon material-icons dismiss_icon" @click="dismissNotification">close</span>
            </div>
            <div class="notification_body">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: [
        "show",
        "headerText"
    ],
    emits: ["dismissNotification"],
    methods: {
        dismissNotification() {
            this.$emit("dismissNotification");
        }
    }
}
</script>

<style scoped>
.notification_wrapper {
    right: 6px;
    bottom: 6px;
    z-index: 110;
    position: fixed;
    width: 318px;
    border-radius: 3px;
    background-color: white;
    font-size: var(--sniffer-font-size-sub-menu);
    border: 2px solid var(--sniffer-color-border);
}

.notification_header {
    display: flex;
    padding: 6px 12px;
    align-items: center;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    justify-content: space-between;
    background-color: var(--sniffer-color-secondary);
}

.icon_cover {
    width: 48px;
    height: 48px;
    overflow: hidden;
    padding: 9px 4.5px;
    border-radius: 50%;
    margin-right: 12px;
    background-color: white;
}

.icon_cover img {
    width: 36px;
    height: 30px;
}

.title_wrapper {
    transform: translateX(-12px);
    font-weight: var(--sniffer-font-weight-medium);
}

.dismiss_icon {
    cursor: pointer;
    font-size: 18px;
    color: var(--sniffer-color-icon-small);
}

.notification_body {
    margin: 12px 0;
    padding: 6px 12px;
}

.notification-enter-from,
.notification-leave-to {
    transform: translateY(180px);
}

.notification-enter-active {
    transition: all 0.3s ease-out;
}

.notification-leave-active {
    transition: all 0.3s ease-in;
}

.notification-enter-to,
.notification-leave-from {
    transform: translateY(0);
}
</style>